import { useState } from 'react';

const faqs = [
  {
    q: '私密视频是否完全免费？需要注册才能观看吗？',
    a: '私密视频旗下红桃视频、西瓜视频免费、小蓝视频、茄子视频等频道均提供免费在线观看服务。无需注册即可直接访问，高清画质流畅播放不缓冲，让您随时随地享受优质视频内容。部分独家资源可能需要简单注册，但核心服务始终保持免费。',
  },
  {
    q: '视频播放卡顿或缓冲怎么办？支持哪些清晰度？',
    a: '我们采用先进的CDN加速技术，确保红桃视频、西瓜视频、小蓝视频等全平台资源播放流畅不缓冲。平台支持标清、高清、超清多档清晰度自动切换，根据您的网络状况智能匹配最佳画质。如遇播放问题，可尝试切换清晰度或更换网络环境。',
  },
  {
    q: '久久视频和芒果视频的内容更新频率是怎样的？',
    a: '私密视频平台保持每日内容更新，久久视频经典专区每周新增修复版经典影片，芒果视频独家内容与卫视同步上线。热播剧集和综艺节目第一时间更新，确保您不会错过任何精彩内容。更新状态可在首页#updates区域实时查看。',
  },
  {
    q: '可以在手机上观看吗？有没有移动端App？',
    a: '当然可以！私密视频全平台完美适配手机、平板和电脑端，无需下载即可通过浏览器直接访问。如果您希望获得更好的移动端体验，可以查看我们#app区域的移动端专属入口，支持离线缓存和投屏播放功能，随时随地畅享高清视频。',
  },
];

export default function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  return (
    <section id="faq" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-3xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <span className="inline-block px-3 py-1 rounded-full bg-accent-100 text-accent-700 text-xs font-medium mb-4">
            常见问题
          </span>
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-900">
            常见问题解答
          </h2>
          <p className="mt-2 text-sm text-foreground-500">
            关于私密视频平台的常见疑问，这里都能找到答案
          </p>
        </div>

        <div className="space-y-3">
          {faqs.map((faq, i) => (
            <div
              key={i}
              className="rounded-xl border border-background-200/70 overflow-hidden"
            >
              <button
                className="w-full flex items-center justify-between p-5 text-left bg-background-50 hover:bg-background-100 transition-colors cursor-pointer"
                onClick={() => setOpenIndex(openIndex === i ? null : i)}
              >
                <h3 className="text-sm md:text-base font-medium text-foreground-900 pr-4">
                  {faq.q}
                </h3>
                <div className={`w-6 h-6 flex items-center justify-center flex-shrink-0 transition-transform duration-300 ${openIndex === i ? 'rotate-180' : ''}`}>
                  <i className="ri-arrow-down-s-line text-lg text-foreground-500"></i>
                </div>
              </button>
              <div
                className={`overflow-hidden transition-all duration-300 ${
                  openIndex === i ? 'max-h-96 opacity-100' : 'max-h-0 opacity-0'
                }`}
              >
                <div className="px-5 pb-5">
                  <p className="text-sm text-foreground-600 leading-relaxed">{faq.a}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}